import React from 'react';
import cl from './ShippingPolicy.module.css';



const ShippingPolicy = (props) => {
    return (
        <section className={cl.app_policy}>
          <h1>Politica di spedizione</h1>
           <p>Il nostro obiettivo è offrirti le migliori opzioni di spedizione, indipendentemente da dove vivi. Consegniamo a centinaia di clienti in tutto il mondo
                 ogni giorno e ci impegniamo a fornirti servizi del massimo livello.</p>
           <p>Sappiamo che una volta acquistato qualcosa non vedi l'ora di ricevere il tuo ordine il prima possibile. Per ulteriori dettagli, vedere di seguito
                 la politica di spedizione.</p>
           <p>D: Potete garantire i tempi di spedizione?</p>
             <p>R: Purtroppo no, poiché dipendono dal servizio postale. Spediamo gli ordini non appena possibile dopo aver ricevuto il tuo
                 pagamento. Non elaboriamo gli ordini durante il fine settimana o nei giorni festivi.</p>
             <p>D: Posso tracciare il mio ordine?</p>
             <p>R: Sì! Il nostro servizio è completamente tracciabile sui siti web.</p>
             <p>D: Dove spedite?</p>
             <p>R: Spediamo in tutto il mondo.</p>
             <p>D: Posso richiedere un rimborso se il mio ordine non arriva in tempo per una determinata data?</p>
             <p>R: No, siamo spiacenti ma non possiamo rimborsare gli ordini che sono già stati spediti. Puoi restituire l'ordine se lo desideri
                 rimborso però.</p>
             <p>A causa dell'influenza del COVID-19 e delle restrizioni politiche di vari paesi, si verificherà un notevole ritardo in tutti i servizi espressi
                 consegne e la logistica non può garantire completamente il limite di tempo.</p>
             <p>Tempi di consegna: 2-7 giorni, tempi di spedizione: 7-15 giorni.</p>
        </section>
    );
}

export default ShippingPolicy;